const _cloudfrontHost =
  process.env.REACT_APP_IMAGE_URL || "https://indxx.gumlet.io";

export function getImageUrl(url: any) {
  if (!url || url === "") {
    return "No Image Key";
  } else if (url.includes("https://prod-indxx-assets.s3.ap-south-1.amazonaws.com")) {
    return `${_cloudfrontHost}/${url.replace("https://prod-indxx-assets.s3.ap-south-1.amazonaws.com/", "")}`;
  } else if (url[0] === "/") {
    return `${_cloudfrontHost}/${url.slice(1, url.length)}`;
  } else {
    return `${_cloudfrontHost}/${url}`;
  }
}
